var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 94,
    viewBox: "0 0 62 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_8303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9607 12.0982H16.0703V14.9211H45.9607V12.0982Z",
    fill: "#75869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7569 3.28127V0H20.2715V3.28127H23.2634V8.84776H20.2715V12.129H41.7569V8.84776H39.0636V3.28127H41.7569ZM36.4426 8.84776H25.5836V3.28127H36.4426V8.84776Z",
    fill: "#30365B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9048 24.8729H1.12402V82.1156H60.9048V24.8729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M60.9157 71.2206V69.656H60.9048V24.8729H53.9639V69.656H1.08447L1.10862 70.2311L53.9639 71.106V73.9157H1.08447L1.10862 74.4886L53.9639 75.3657V82.1156H60.9048V75.4803H60.9157V73.9157H60.9048V71.2206H60.9157Z",
    fill: "#B4B6C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.907 24.8729H1.12402C6.30002 18.6299 12.5472 14.9608 16.4984 14.9608H45.5283C47.506 14.9608 50.0567 15.8775 52.7589 17.5743C55.461 19.2733 58.3168 21.7503 60.9048 24.8729H60.907Z",
    fill: "#EEF0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5283 92.0189H16.5005C12.5472 92.0189 6.30002 88.3498 1.12402 82.1068H60.9048C55.7288 88.3498 49.4816 92.0189 45.5283 92.0189Z",
    fill: "#B4B6C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.765 91.7015H14.2637V94H47.765V91.7015Z",
    fill: "#30365B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.761 31.7065H1.03613V35.867H13.761V31.7065Z",
    fill: "#B4B6C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0836 38.5401H5.771V48.0468H23.0836V38.5401Z",
    fill: "#B4B6C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1527 73.9642H0.849495C0.381944 73.9642 0 73.583 0 73.1114C0 72.642 0.379749 72.2585 0.849495 72.2585H61.1527C61.6224 72.2585 62.0022 72.6398 62.0022 73.1114C62.0022 73.5807 61.6224 73.9642 61.1527 73.9642Z",
    fill: "#EEF0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1527 69.656H0.849495C0.381944 69.656 0 69.2747 0 68.8031C0 68.3338 0.379749 67.9503 0.849495 67.9503H61.1527C61.6224 67.9503 62.0022 68.3316 62.0022 68.8031C62.0022 69.2725 61.6224 69.656 61.1527 69.656Z",
    fill: "#EEF0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9066 24.8729H53.9636C51.1473 20.8115 44.0791 16.3425 40.1982 14.9608H45.5279C47.5057 14.9608 50.0563 15.8775 52.7585 17.5743C55.4606 19.2733 58.3164 21.7503 60.9044 24.8729H60.9066Z",
    fill: "#B4B6C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_8303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 94,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottel);
export default __webpack_public_path__ + "static/media/bottel.f4f87da7edb13752d4459897a4f42f0b.svg";
export { ForwardRef as ReactComponent };